import { useQuery } from '@tanstack/react-query'

const API_URL = '/api/affiliate/dashboard'

/** Money arrives as strings — Django serialises Decimal that way, and parsing it
 *  into a float here would reintroduce exactly the rounding the backend avoids. */
export type Statement = {
    period_start: string | null
    period_end: string | null
    fees_collected: string
    paid_out: string
    profit: string
    rate: string
    share: string
    /** BR1's take from the cohort this period; the share never exceeds it (D-001). */
    br1_take?: string
    /** The share was lowered to BR1's take (D-001). */
    capped?: boolean
    is_negative_period: boolean
}

export type AffiliateDashboard = {
    username: string
    url: string
    funnel: { visits: number; signups: number; active_players: number }
    lifetime: Statement
    current_period: Statement
    referrals: Array<{
        referred_user__username: string
        created_at: string
        is_active_player: number
    }>
    payouts: Array<{
        period_start: string
        period_end: string
        amount: string
        paid_at: string
        method: string
        reference: string
    }>
}

export const useAffiliateDashboard = () =>
    useQuery<AffiliateDashboard>({
        queryKey: [API_URL],
        queryFn: async () => {
            const res = await fetch(API_URL)
            if (!res.ok) throw new Error('Could not load your affiliate dashboard.')
            return res.json()
        },
        retry: false,
    })
